import React, { FC } from "react";
import { GalleryCollage } from "./GalleryCollage";
import { Gallery } from "../Gallery";

export type IGalleryItemProps =
  | {
      type: "video";
      src: string;
      caption?: string;
      thumbnail?: string;
    }
  | {
      type: "image";
      src: string;
      alt: string;
      caption?: string;
    };

export interface GalleryProps {
  gallery: IGalleryItemProps[];
  galleryMD: IGalleryItemProps[];
}

const GalleryNew: FC<GalleryProps> = ({ gallery, galleryMD }) => {
  if (gallery.length === 0) {
    return null;
  }

  if (gallery.length === 1) {
    return <Gallery gallery={gallery} />;
  }

  if (gallery.length >= 2) {
    return (
      <div>
        <div className="max-md:hidden">
          <GalleryCollage gallery={gallery} galleryMD={galleryMD} />
        </div>
        <div className="md:hidden">
          <Gallery gallery={gallery} />
        </div>
      </div>
    );
  }

  return <Gallery gallery={gallery} />;
};

export default GalleryNew;
